//组件对象，大写
import realPageTable from './realPageTable.vue'
export default realPageTable
